import {IKuPiper} from '@/middleware/types';
import {transformSrc} from './utils';

export const initProxy = (kuPiper: IKuPiper, options: any) => {
    // 编辑器配置项
    kuPiper.registerProxy(kuPiper.proxyNameMap.editorPluginOptionsProxy, {
        options,
        fn: (callback: any) => {
            // 添加自定义配置项
            const options = callback();
            const externalRepoGeneralConfig = {
                enable: false,
            };
            const externalRepoOnlineTodoConfig = {
                open: false,
            };
            // 第三方插件
            options.embed = {
                codePen: true,
                figma: true,
                agent: true,
                flowIframe: false,
            };
            // 日程
            options.embedInline = {
                renderEmbedInline: null,
                showBlockWorkCard: false,
            };
            // 评论
            options.comment = {
                ...options.comment,
                enableShare: false,
                enableBindGroup: false,
                isQuickFollowComment: false,
                getSlotComponent: false,
                showUserDetails: false,
                placeholder: '输入评论',
                replyPlaceholder: '输入评论',
                showReplyButton: false,
            };
            options.attachment.convertPDF2Word = undefined;
            // 侧栏块引用
            options.slide = {
                ...options.slide,
                showNewSlideMenu: false,
                // AI功能已经全量，默认为true
                enableAISlide: false,
                enableAISlideMenu: false,
                enableAIMarkKeyPoint: false,
                // 开启卡片块引用
                enableCardBlockRef: false,
                // 展示块引用相关入口
                disableCardCopyAndShare: false,
                showCardAuthors: true,
                // 单张卡片适配全屏大小功能开关
                singleCardSizeAdaptation: true,
                // 启用卡片基础优化（新版卡片拖拽菜单）
                enableCardDrag: true,
                // 只读态下hover卡片右侧的最近编辑时间是否展示作者详情，默认为true
                showAuthorsDetails: false,
                enableQuickInsert: true,
            };
            options.todolist = {
                ...options.todolist,
                autoTransOnlineTodo: false,
            };
            // ocr
            options.image.tooltipOCREnable = false;
            // 如流待办
            options.onlineTodoList = externalRepoOnlineTodoConfig;
            // 星链
            options.highlight = externalRepoGeneralConfig;
            // 阅读统计
            options.statistics = externalRepoGeneralConfig;
            // 块引用
            options.transclusion = externalRepoGeneralConfig;
            // 智能创作
            options.ai = externalRepoGeneralConfig;
            // @人
            options.mention = externalRepoGeneralConfig;
            // 模板库
            options.material = externalRepoGeneralConfig;

            options.tableOfContents = {
                // 文档目录卡
                showInserts: true,
            };
            // editor 整体配置
            options.editorConfig = {
                ...options.editorConfig,
                // 划选转分栏（非 ai 能力）
                isOpenChangeLayoutEntry: true,
                // 表格划选工具条
                showTableSelectionMenu: true,
                showCollaboratorAvatarTooltip: false,
            };
            options.image.transformHost = transformSrc;
            return options;
        },
    });
    // 底部评论配置项
    kuPiper.registerProxy(kuPiper.proxyNameMap.commentEditorConfigProxy, {
        options,
        fn: (callback: any) => {
            // 添加自定义配置项
            const options = callback();
            const externalRepoGeneralConfig = {
                enable: false,
            };
            // @人
            options.mention = externalRepoGeneralConfig;
            options.image.transformHost = transformSrc;
            return options;
        },
    });

    kuPiper.registerProxy(kuPiper.proxyNameMap.editorCommonOptionsProxy, {
        options,
        fn: (callback: any) => {
            const options = callback();
            // 禁止加载flowsdk
            options.thirdPartyOption = {
                flowSDK: {enable: false},
            };
            return options;
        },
    });
};
